import { Grid, Typography } from '@mui/material'

type Props = {
  children: React.ReactNode
  label: string
  grid?: [number, number]
}
export const CustomGrid = (props: Props) => {
  const { children, label, grid = [4, 8] } = props

  return (
    <Grid container spacing={2} sx={{ minHeight: '115px', mb: 1 }}>
      <Grid item xs={12} md={grid[0]}>
        <Typography mt={2}>{label}</Typography>
      </Grid>
      <Grid item xs={12} md={grid[1]}>
        {children}
      </Grid>
    </Grid>
  )
}
